'use client'

import { memo, useMemo } from 'react'

import { GameArea } from './components/GameArea'
import { WordHuntProvider } from './context'
import { WordHuntService } from './services/gameService'
import type { GameConfig, GameActions } from './types'

/**
 * Props do componente WordHuntGame
 */
interface WordHuntGameProps {
  wordsList: string[]
  showWords?: boolean
  onComplete: () => void
  onError: () => void
}

/**
 * Componente principal do jogo WordHunt
 * Segue princípios de Clean Code: componente focado, memoizado, bem tipado
 */
export const WordHuntGame = memo<WordHuntGameProps>(
  ({ wordsList, showWords = false, onComplete, onError }) => {
    // Memorizar configuração do jogo para evitar recriações
    const gameConfig = useMemo<GameConfig>(() => {
      return WordHuntService.createGameConfig(wordsList, showWords)
    }, [wordsList, showWords])

    // Memorizar ações do jogo para evitar recriações
    const gameActions = useMemo<GameActions>(
      () => ({
        onComplete,
        onError
      }),
      [onComplete, onError]
    )

    return (
      <WordHuntProvider config={gameConfig} actions={gameActions}>
        <div className="mx-auto flex min-h-0 w-full max-w-lg flex-col items-center justify-center overscroll-contain rounded-xl bg-jacaranda/20 px-3 py-3 supports-[padding:max(0px)]:pb-[max(1rem,env(safe-area-inset-bottom))] sm:p-4">
          <GameArea showWords={showWords} />
        </div>
      </WordHuntProvider>
    )
  }
)

WordHuntGame.displayName = 'WordHuntGame'
